/**
 * @file ManagerEvents.ts
 * @description RapooDeviceManager 对外抛出的根设备生命周期事件。
 * Web 层应从这里引用事件名，避免散落书写 device:* 字符串。
 */

import type { BaseDevice } from '../runtime/BaseDevice'

export const ManagerEvents = {
  /** 根设备已经完成驱动创建和 open，可进入业务使用。 */
  DeviceConnected: 'device:connected',
  /** 根设备物理断开或通道关闭，manager 已从根设备列表移除。 */
  DeviceDisconnected: 'device:disconnected',
  /**
   * 独立 Boot VID/PID 被多个型号共用，且无 APP 前置归属（刷新丢内存且无持久记录）时触发。
   * Web 应弹出型号选择，再调用 `claimBootOwner` 继续建连。
   */
  BootAmbiguous: 'boot:ambiguous',
} as const

export type ManagerEventName = (typeof ManagerEvents)[keyof typeof ManagerEvents]

/** Boot 身份多型号消歧载荷 */
export type BootAmbiguousPayload = {
  vendorId: number
  productId: number
  /** 候选产品型号（manifest.model） */
  models: string[]
}

export type ManagerEventPayloadMap = {
  [ManagerEvents.DeviceConnected]: BaseDevice
  [ManagerEvents.DeviceDisconnected]: BaseDevice
  [ManagerEvents.BootAmbiguous]: BootAmbiguousPayload
}
